import i18next from 'i18next'
import bowser from 'bowser'
import { message } from '../redux/actions'

export default function compatibilityCheck(store) {
  if (bowser.ios && !bowser.safari) {
    store.dispatch(message(i18next.t('message.browser.alternative', { browser: 'Safari' })))
  }
  if (bowser.msie) {
    store.dispatch(message(i18next.t('message.browser.not.supported')))
  }
}
